import { useContext } from 'react';
import t from 'react-translate';

import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import { config } from '../../../../../config/pendo.config.json';
import AiConversationContext, { AIRolePlayStatus, RolePlayInteractionMode } from './context';
import AvatarContainer from './avatar-container';
import ScenarioDetails from './scenario-details';

const ScenarioSection = () => {
  const {
    aiRolePlayStatus,
    showScenarioDetails,
    setShowScenarioDetails,
    interactionMode,
  } = useContext(AiConversationContext);

  const handleToggle = () => setShowScenarioDetails(!showScenarioDetails);

  return (
    <>
      {(interactionMode === RolePlayInteractionMode.TEXT_MODE
      || aiRolePlayStatus !== AIRolePlayStatus.IN_PROGRESS)
        && <AvatarContainer />}
      {showScenarioDetails && <ScenarioDetails />}
      {(aiRolePlayStatus === AIRolePlayStatus.IN_PROGRESS
        || aiRolePlayStatus === AIRolePlayStatus.COMPLETED) && (
        <ClickableContainer
          className='mb-0 text-primary d-flex justify-content-center scenario-toggle-button text-small semi-bold'
          onClick={handleToggle}
          data-qa={config.pendo.activities.aiRolePlay.conversationModal.toggleScenario}
        >
          <NvIcon
            icon='gen-ai'
            size='xss-smallest'
            className='d-flex align-items-center'
          />
          <p className='mb-0 ml-1'>
            {showScenarioDetails
              ? t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.HIDE_SCENARIO()
              : t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.SHOW_SCENARIO()}
          </p>
        </ClickableContainer>
      )}
    </>
  );
};

export default ScenarioSection;
